import axios from '../axios'
import store from '../store/store'

export default class FiltersService {

  updateFavOrder(orderDetails) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/updateFavOrder'
        
        var response = await axios.put(path, orderDetails)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCurrUserFavFilters() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getCurrUserFavFilters'
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  setSavedFilterFav(filterId, favorite) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/setSavedFilterFav/' + filterId + '/' + favorite;
        
        var response = await axios.put(path)

        this.getCurrUserFavFilters()
          .then(data => {
            store.dispatch('commons/favoriteFilters', data)
          })
          .catch(error => {
            store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCurrUserFavFilters"'
            })
          })
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  setUserViewColWidth(userViewFilterId, width) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/setUserViewColWidth/' + userViewFilterId + '/' + width;
        
        var response = await axios.put(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUserViewFilterConditiosn(filterId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/userViewFilterConditions/' + filterId;
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDateModifiers(filterId) {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/datemodifiers`]) {
        resolve(store.getters[`commons/datemodifiers`])
  
      } else {
        try {
          var path = '/v1/dateModifiers';
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/datemodifiers`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  deleteFilter(filterId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/delUserViewFilter/' + filterId;
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDefUserViewFilterByHard(viewId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/defUserViewFilter/' + viewId + '/';
        
        var response = await axios.get(path)
          
        try {
          store.dispatch(`commons/defUserViewFilter${viewId}`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDefUserViewFilter(viewId) {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/defUserViewFilter${viewId}`]) {
        resolve(store.getters[`commons/defUserViewFilter${viewId}`])
  
      } else {
        try {
          var path = '/v1/defUserViewFilter/' + viewId + '/';
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/defUserViewFilter${viewId}`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getUserViewFiltersbyUser(viewId, userId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/userViewFiltersbyUser/' + viewId + '/' + userId;
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUserViewFiltersByHard(viewId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/userViewFilters/' + viewId + '/';
        
        var response = await axios.get(path)
          
        try {
          store.dispatch(`commons/userViewFilters${viewId}`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUserViewFilters(viewId) {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/userViewFilters${viewId}`]) {
        resolve(store.getters[`commons/userViewFilters${viewId}`])
  
      } else {
        try {
          var path = '/v1/userViewFilters/' + viewId + '/';
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/userViewFilters${viewId}`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  
  filtersCustomRequest(requestPath) {
    var parts = requestPath.split('/')
    // 
    
    return new Promise(async function(resolve, reject) {
      if (
        parts[1]
        && store.getters[`commons/${parts.slice(1).join('/').toLowerCase()}`]
        && store.getters[`commons/${parts.slice(1).join('/').toLowerCase()}`].length
      ) {
        resolve(store.getters[`commons/${parts.slice(1).join('/').toLowerCase()}`]) 
  
      } else {
        try {
          var path = '/' + requestPath
          
          var response = await axios.get(path)
  
          // 
          if (parts[1]) {
            try {
              store.dispatch(`commons/${parts.slice(1).join('/').toLowerCase()}`, response.data)
            } catch(e) {}
          }
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    });

  }
  
  resetColumns(viewId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/reseCurrenttUserViewFields/' + viewId
        
        var response = await axios.get(path)

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  getColumnSelectionByHard(viewId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/currentUserViewFields/' + viewId
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/columnsSelection${viewId}`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  getColumnSelection(viewId) {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/columnsSelection${viewId}`]) {
        resolve(store.getters[`commons/columnsSelection${viewId}`])
  
      } else {
        try {
          var path = '/v1/currentUserViewFields/' + viewId
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/columnsSelection${viewId}`, response.data)
          } catch(e) {}

          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    });
  }
  
  deleteCurrentUserViewFields(viewId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/deleteCurrentUserViewFields/' + viewId
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  resetColumnSelection(viewId, userId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/resetUserViewFields/' + userId + '/' + viewId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  saveColumnSelection(selection) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/userViewField'
        
        var response = await axios.post(path, selection)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  getDBViews() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/dbviews'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  getDBView(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/dbView/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  getDBViewFields(id) {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/dbViewFields${id}`]) {
        resolve(store.getters[`commons/dbViewFields${id}`])
  
      } else {
        try {
          var path = '/v1/dbViewFields/' + id
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/dbViewFields${id}`, response.data)
          } catch(e) {}

          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    });
  }
  
  putUserViewFilter(filter) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/userViewFilter/' + filter.id
        
        var response = await axios.put(path, filter)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }
  
  postUserViewFilter(filter) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/userViewFilter'
        
        var response = await axios.post(path, filter)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

}